import { type InputHTMLAttributes, forwardRef } from "react";
import { IconSearch } from "@tabler/icons-react";
import { cn } from "../../lib/utils";

type SearchInputProps = Omit<
  InputHTMLAttributes<HTMLInputElement>,
  "type" | "placeholder" | "aria-label"
> & {
  /** Already translated; it is also the field's accessible name. */
  placeholder: string;
};

/**
 * The desktop field that filters a list in place (Figma
 * "D3.settings.specialty.search"): a grey 36px pill, the magnifier leading.
 * `className` sets the outer box (margins, width); the look is fixed.
 */
const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(
  function SearchInput({ placeholder, className, ...props }, ref) {
    return (
      <label
        className={cn(
          "flex h-9 shrink-0 items-center gap-2 rounded-lg bg-ds-black/4 px-2.5 text-ds-slate-600",
          className
        )}
      >
        <IconSearch aria-hidden className="size-4 shrink-0" stroke={1.25} />
        <input
          ref={ref}
          type="search"
          aria-label={placeholder}
          placeholder={placeholder}
          className="min-w-0 flex-1 border-none bg-transparent font-dm-sans text-sm text-ds-slate-900 outline-none placeholder:text-ds-slate-600"
          {...props}
        />
      </label>
    );
  }
);

export { SearchInput, type SearchInputProps };
